export const ProjectUserGroup = {
  list: function() {
        var options = {
          bDeferRender: true,
          data: JSON.parse(jQuery("#project-user-group-data").html()),
          info: false,
          lengthChange: false,
          language: {
            searchPlaceholder: I18n.t('search')
          },
          pageLength: 20,
          autoWidth: false,
          initComplete: function () {
            DataTablesHelper.setAutoComplete(jQuery("#user-groups"));
          },
          columnDefs: [
            {
              targets: [1],
              searchable: false,
              sortable: false,
            }
          ],
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          },
        };
    
        var table = jQuery("#user-groups");
        table.DataTable(options);
  }
}